import ShopsViews from './ShopsView';

export default ShopsViews;
